<template>
  <div :class="$style[classes]">
    <pt-form-list-item label="链接名称：" required>
      <wt-input data-vv-as="链接名称" v-validate="'required'" v-model="formValue.title" placeholder="请输入链接名称" />
    </pt-form-list-item>
    <pt-form-list-item label="链接类型：" required>
      <wt-selector :options="linkTypes" v-model="formValue.objectType" placeholder="请选择链接类型"  data-vv-as="链接类型" v-validate="'required'"></wt-selector>
    </pt-form-list-item>
    <pt-form-list-item label="原始链接：" required>
      <wt-input data-vv-as="原始链接" v-validate="'required'" v-model="formValue.sourceUrl" placeholder="请输入原始链接" />
    </pt-form-list-item>
    <pt-form-list-item label="目标来源：" required>
      <wt-checkbox :checkList="targetFroms" v-model="formValue.froms"  data-vv-as="目标来源" v-validate="'required'" placeholder="请选择链接目标来源" ></wt-checkbox>
    </pt-form-list-item>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { linkTypes, targetFroms } from 'json/link-manage'
// 组件class前缀
const prefixCls = 'pt-link-form'

export default {
  name: 'pt-link-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      linkTypes: linkTypes,
      targetFroms: targetFroms,
      formValue: {

      }
    }
  },
  watch: {
    formValue: {
      handler: function (val) {
        // this.$emit('input', val)
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-link-form{
  :global{
    .wt-selector{
      max-width:350px
    }
  .wt-input{
    max-width:350px
  }
  }
}
</style>
